import { fetchApi, getOrganisationId, getUserId } from 'shared/functions';

export const editProfileService = async ({ payload }) => {
  const userId = getUserId();
  const organisationId = getOrganisationId();

  const params = {
    method: 'PUT',
    body: JSON.stringify(payload),
  };

  const response = await fetchApi(`/sso/organisations/${organisationId}/users/${userId}`, params);

  return response.json();
};
